// extracted by mini-css-extract-plugin
export default {"form":"styles_form__+kbYr","input":"styles_input__nM3f2"};